export default __webpack_public_path__ + "static/media/cancel-icon.782116dc.svg";